<template>


  <div>
  <link href="https://fonts.googleapis.com/css2?family=Noto+Serif+SC&display=swap" rel="stylesheet">
    <header>
      <Header />
    </header>
    <div>
      <div id="main">
        <section class="artWorkCateTop">
          <div v-if="this.$route.path.indexOf('/organizer') >= 0" class="artWorkCateTopTitle">
            <div class="inner4">
              <h1>主催者企画</h1>
              <p class="titleSub">Exhibitions by Organizer</p>
            </div><!-- /inner4-->
          </div><!-- /photographersListTitle-->


          <div v-if="isSelected('/organizer')" class="artWorkInfo">
            <div class="inner2">
              <p class="mainTxt">
              東京カメラ部は、写真は撮影者による表現活動という側面に加えて、鑑賞を通じた感動共有により、人々の幸福を増幅させる可能性を秘めていると信じてます。
              そして、日本や世界各地で撮影された様々なジャンルの写真を、日本を含む世界各国の方々に見ていただくことによって、日本を含む世界の魅力を伝えることは、より寛容で平和な世界の実現につながると信じています。
              そのため、投稿者の方々の表現活動の支援に加えて、日本を含む世界中の方々に「世界は愛おしく守るべき価値があるものだ」ということを再認識していただくために、東京カメラ部に投稿いただいた素晴らしい写真を、東京カメラ部の各種アカウントで紹介させていただいています。<br>
              <br>
              そんな思いから、弊社は2019年よりWeiboの運営を開始し、少しずつではありますが、写真を通じた日中の交流を進めてまいりました。
              今までに、そして現在でも日本・中国の投稿者の方から多くのご協力をいただいてること感謝申し上げます。
              また、今年は「私がおススメしたい絶景」をテーマに、Weiboでフォトコンテストを開催し、ありがたいことに100を越える作品のご応募をいただくことができました。<br>
              <br>
              本ページでは、東京カメラ部Weiboに作品をご投稿いただいた方の中から4名*、フォトコンテストで最優秀賞を受賞された方の中から1名、合計5名の作品を展示しています。ぜひ皆さまの作品をお楽しみください。<br>
              <br>
              今後も中国と日本の文化交流の架け橋となれるよう、またそれが寛容で平和な世界の実現への一歩だと信じて、日本と世界の交流を続けてまいります。<br>
              <br>
              *Weiboに作品をご投稿いただいた方4名のうち、1名の作品は後日追加いたします。
              </p>

              <p class="mainTxt txtCh">
              东京相机部（以下简称“我们”）相信，除了达到自我展现这一目的，摄影艺术还拥有着通过欣赏来分享情感，从而放大人们幸福感的可能性。
              除此之外，我们还相信，通过让包括日本在内的世界各地的人们欣赏拍摄于包括日本在内的世界各地的各类摄影作品，从而展现包括日本在内的世界各地的魅力，以实现一个更加宽容与和平的世界。
              因此，在支援投稿人创作活动的同时，为了希望让包括日本在内的世界各地的人们能够再次认识到“世界是可爱的，是值得我们去珍爱的”这一点，我们把精彩的投稿作品分享并介绍于东京相机部各类媒体平台。<br>
              <br>
              正因有着如此理念，我们自2019年开始运营微博账号，通过摄影作品来促进中日间的交流贡献我们小小力量。
              我们要特别感谢来自日本和中国的投稿人从前及现在的协力。
              此外，今年我们于微博举办了以“我的绝景推荐”为主题的摄影比赛，并有幸收获了100多组作品的应募。<br>
              <br>
              本展示页面，我们将展示来自投稿于东京相机部微博的作者中4名*，摄影比赛最优秀奖获奖人1名，共5名作者的作品。敬请欣赏。<br>
              <br>
              我们希望成为中日文化交流的桥梁，并相信这是朝着实现一个宽容与和平的世界迈出的一步，今后也将继续进行着日本与世界的交流。<br>
              <br>
              *我们将于近日追加其中1名作者的作品。
              </p>

            </div><!-- /inner2-->
          </div><!-- /artWorkInfo-->

          <div class="artWorkCateTopBody">
            <div class="inner2">

              <div v-if="this.$route.path.indexOf('/organizer') >= 0" class="listBlock">
                <template v-for="category of ['Weibo']">
                  <div :key="category">
                    <h2>{{category}}</h2>
                      
                    <div class="listBlockInner">
                      <template v-for="(winner, index) of winnerListByCategory(category)">
                        <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                          <div class="thumbnailImg">
                              <router-link :to="workUrl(winner)">
                                <img :src="winner.mainImageUrl" :alt="winner.mainImageTitle" />
                              </router-link>
                          </div>
                          <h3><router-link :to="workUrl(winner)">{{ winner.name }}</router-link></h3>
                        </div>
                      </template>
                    </div><!-- /listBlockInner-->

                  </div>
                </template>
              </div><!-- /listBlock-->
            </div><!-- /inner2-->
          </div><!-- /photographersListBody-->
        </section><!-- /photobook-->

      </div><!-- /main-->
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    getArtworksCode (winner) {
      if (!this.awardTypeCode || !winner) return
      return this.awardTypeCode[winner.awardType]
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    awardTypeList () {
      if (this.$route.path === '/organizer') {
        return [11, 12, 13, 14, 15, 16]
      }
    },
    winnerList (type) {
      return this.winners.filter((winner) => { return winner.awardType === type })
    },
    winnerListByCategory (category) {
      return this.winners.filter((winner) => {
        if (category.indexOf('Twitter') >= 0) {
          return [11, 12, 13].indexOf(winner.awardType) >= 0
        } else if (category.indexOf('Weibo') >= 0) {
          return winner.awardType === this.EnumAwardTypeWeibo
        } else {
          return winner.awardType === this.EnumAwardTypeJtg
        }
      })
    },
    winnerListBySubCategory (subCategory) {
      return this.winners.filter((winner) => {
        if (subCategory.indexOf('スナップ') >= 0) {
          return winner.awardType === this.EnumAwardTypeTwitterSnap
        } else if (subCategory.indexOf('ポスター') >= 0) {
          return winner.awardType === this.EnumAwardTypeTwitterPoster
        } else {
          return winner.awardType === this.EnumAwardTypeTwitterPortrait
        }
      })
    },
    workUrl (winner) {
      let path = ''
      if (winner.awardType == this.EnumAwardTypeTwitterPoster) {
        path = `/organizer/twitter/poster/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeTwitterSnap) {
        path = `/organizer/twitter/snap/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeTwitterPortrait) {
        path = `/organizer/twitter/portrait/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeJtg) {
        path = `/organizer/jtg/${winner.id}`
      } else if (winner.awardType == this.EnumAwardTypeWeibo) {
        path = `/organizer/weibo/${winner.id}`
      }
      return path
    },
  },
  created () {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
